/* eslint-disable prettier/prettier */
import React from 'react';
//import {BsChevronLeft, BsChevronRight} from "react-icons/bs";
import '../index.css';
import './events.css';
//import { Link } from "react-router-dom";

function Events() {
  /*<div className="ffdRow">
        <div className="eventCol">
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "LFCF_poster2a.png"}
            alt="Johnny Cash event"
          ></img>
        </div>
      </div>*/

  /*<div className="eventCol">
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "1.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "2.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "3.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>

          <div style={{ background: "green", color: "white" }}>
            <p className="teaBooking">
              Please advise requested seating time(s) and number of people. The
              tearoom manager will reach out to you to confirm your reservation.
              Reservations are not guaranteed until you receive confirmation.
            </p>
            <p className="teaBooking">$34.99 per person / $32.99 per Senior</p>
            <p className="teaBooking" style={{ color: "white" }}>
              <a
                style={{ color: "white", fontWeight: "bold" }}
                href="https://docs.google.com/forms/d/e/1FAIpQLScoLObtSLDYYP7blWXjBwRSuq9kTacunWgCzgD-dvujBAIOZw/viewform"
                target="_blank"
                rel="noreferrer"
              >
                Click here to open your booking request
              </a>
            </p>
          </div>
        </div>*/
  /*May 11th   Mother's Day Tea
May 31st   Afternoon Tea

June 1st     Afternoon Tea
June 14th   Afternoon Tea
June 15th   Afternoon Tea
June 28th   Afternoon Tea
June 29th   Afternoon Tea


July 12th   Afternoon Tea
July 13th   Afternoon Tea
July 26th   Afternoon Tea
July 27th   Afternoon Tea

Sept. 13th   Afternoon Tea
Sept. 14th   Afternoon Tea
Sept. 27th   Afternoon Tea
Sept 28th    Afternoon Tea

Oct. 4th      Afternoon Tea
Oct. 5th      Afternoon Tea
Oct. 25th    Afternoon Tea
Oct. 26th    Afternoon Tea

Dec. 6th     Jingle Bell HIGH TEA
Dec. 7th     Jingle Bell Tea Afternoon Tea
Dec. 13th   Jingle Bell Tea Afternoon Tea
Dec. 14th   Jingle Bell Tea Afternoon Tea

Seating Times  11:00 am, 12:30 pm, 2:00 pm and 3:30 pm

Please email to londonhf@telus.net to make a Reservation

Please provide the Date for Tea
State the Number of Guests in your Party
Seating Time Preference
Please provide your Phone Number

Warmest regards,

Shelley Niemek - Administrator
Kathy Colquhoun - Tearoom Manager
London Heritage Farm Society*/

  return (
    <div style={{ marginTop: '59px' }}>
      <div className="ffdRow">
        <div style={{ marginBottom: '1px' }} className="eventCol">
          <img
            className="container"
            style={{ marginBottom: '0px' }}
            src={process.env.PUBLIC_URL + '/events/' + 'countryFest2026.png'}
            alt="Country Fest"
          ></img>
        </div>
         <div style={{ marginBottom: '1px'}} className="eventCol">
          <img
            className="container"
            style={{ marginBottom: '0px' }}
            src={process.env.PUBLIC_URL + '/events/' + 'cfestdetails.jpeg'}
            alt="Country Fest"
          ></img>
        </div>
        <div style={{ marginTop: '0px' }} className="ffdRow">
          <div style={{ marginTop: '0px' }} className="eventCol">
            <img
              className="container"
              style={{ marginBottom: '0px' }}
              src={process.env.PUBLIC_URL + '/events/' + 'teamanagerv2.png'}
              alt="tearoomposition"
            ></img>
            <div style={{ color: 'black', fontSize: '25px' }} className="">
              <p>To apply email resume to londonhf@telus.net</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;
